// Metered token operations.
//
// Labels and cost-hint units are NOT hardcoded here anymore — they live in i18n
// under `tokens.operation_labels.*` and `tokens.operation_units.*`. Each entry
// maps the stable backend operation key (do not reorder/rename) to the i18n key
// the component should translate.

export const TOKEN_OPERATIONS = [
  {
    key: 'operation.shadow-trading-history',
    labelKey: 'tokens.operation_labels.shadow_trading_history',
    unitKey: 'tokens.operation_units.per_scenario_day',
  },
  {
    key: 'operation.shadow-trading-hour',
    labelKey: 'tokens.operation_labels.shadow_trading_hour',
    unitKey: 'tokens.operation_units.per_asset_hour',
  },
  {
    key: 'operation.bidding-strategy',
    labelKey: 'tokens.operation_labels.bidding_strategy',
    unitKey: 'tokens.operation_units.per_scenario_day',
  },
  {
    key: 'operation.forward-benchmark',
    labelKey: 'tokens.operation_labels.forward_benchmark',
    unitKey: 'tokens.operation_units.per_scenario_day',
  },
  {
    key: 'operation.imbalance-benchmark',
    labelKey: 'tokens.operation_labels.imbalance_benchmark',
    unitKey: 'tokens.operation_units.per_scenario_day',
  },
];

// Lookup map by operation key for O(1) access to the i18n keys.
const OPERATION_BY_KEY = TOKEN_OPERATIONS.reduce((acc, op) => {
  acc[op.key] = op;
  return acc;
}, {});

/**
 * Resolve the i18n label key for a given operation key.
 * @param {string} operationKey e.g. 'operation.imbalance-benchmark'
 * @returns {string} i18n key (falls back to the raw operation key)
 */
export function tokenOperationLabelKey(operationKey) {
  return OPERATION_BY_KEY[operationKey]?.labelKey || operationKey || '';
}

/**
 * Translate the label for a given operation key.
 * @param {string} operationKey
 * @param {(key: string) => string} t vue-i18n translate function
 * @returns {string} translated label
 */
export function tokenOperationLabel(operationKey, t) {
  const labelKey = OPERATION_BY_KEY[operationKey]?.labelKey;
  if (!labelKey) {
    return operationKey || '';
  }
  return typeof t === 'function' ? t(labelKey) : labelKey;
}
